import { IPaymentRequestPayload, IPaymentProcess } from '@/models'
import { api } from '@/api/api'

export async function createPayment(
    shippingID: string,
    payload: IPaymentRequestPayload
): Promise<IPaymentProcess> {
    const {
        data: { paymentProcess },
    } = await api.post(`shipping/startPayment/${shippingID}`, payload)

    return paymentProcess
}
